"use client";

import React from "react";
import Link from "next/link";

const AreAllOn6RightForYou: React.FC = () => {
  return (
    <section className="w-full py-6 sm:py-8 bg-gradient-to-b from-white to-gray-50">
      <div className="max-w-6xl mx-auto px-4 sm:px-8 md:px-12 space-y-6 text-center md:text-left">
        <h2
          className="
            text-2xl sm:text-3xl font-semibold text-gray-800 text-center
            pb-6 after:content-[''] after:block after:w-[200px] after:h-[3px] after:mx-auto after:mt-2
            after:bg-[linear-gradient(to_right,#AE7D2F_0%,#ECD05B_50%,#AE7D2F_100%)]
          "
        >
          Are All-on-6 Dental Implants Right for You?
        </h2>
        <p className="text-gray-700 text-base sm:text-lg leading-relaxed group hover:bg-gray-50 transition-all duration-300 rounded-md py-1">
          Adults missing most or all of their teeth on one arch are often
          strong candidates. If you&apos;ve been noticing{" "}
          <Link
            href="/blog/signs-you-need-dental-implants/"
            className="inline-block bg-gradient-to-r from-[#AE7D2F] via-[#ECD05B] to-[#AE7D2F] bg-clip-text text-transparent hover:underline transition-all duration-300 ease-in-out"
          >
            signs you may need implants
          </Link>
          , such as loose teeth, bone loss, or failing restorations, All-on-6
          may be the solution worth exploring. Sufficient jawbone density is
          required, though bone grafting is an option when needed. Whether
          you&apos;re switching from dentures or moving past temporary fixes,
          All-on-6 provides a permanent alternative.
        </p>
      </div>
    </section>
  );
};

export { AreAllOn6RightForYou };
export default AreAllOn6RightForYou;
